import React from 'react';

import KeycapSet from '../KeycapSet/KeycapSetImage.jsx'
import KeycapSetProduct from './KeycapSetProduct';

const DecalLaptop = () => {


  return (
    <div className="decal-laptop">
      <KeycapSet />

      <KeycapSetProduct />


    </div>
  );
};

export default DecalLaptop;